import axios from "axios"
import _Util from '../helper/_Util'
import { message } from 'antd';

const URI_API = process.env.REACT_APP_URL_API

const searchParams = async () =>{
    try {
        let result = await axios.get(`${URI_API}/compare-graph/search/params`, {withCredentials: true})
        if(result.data.status){
          return result.data.data
        }else{
          message.error(result.data.msg)
          return []
        }
      }catch(err){
       
       _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
        return false
      }
}

const graphData = async (paramsId, from, to, pattern, offset) =>{
  try {
      let result = await axios.post(`${URI_API}/compare-graph/search`, {paramsId, from, to, pattern, offset}, {withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        message.error(result.data.msg)
        return false
      }
    }catch(err){
      
      _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return false
    }
}


const CompareGraphService = {
    searchParams,
    graphData
}

export default CompareGraphService;